import React, { useEffect, useState } from "react";
import axios from "axios";

const GenerateTiktokThumbnail = ({ video, customStyle, imgStyle }) => {
  const [data, setData] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      try {
        let thumbnail_url;
        if (
          video?.thumbnail_url?.includes("https://denali-thumbnail") ||
          video?.thumbnailUrl?.includes("https://denali-thumbnail")
        ) {
          thumbnail_url = video?.thumbnail_url || video?.thumbnailUrl;
        } else {
          // Denali is generating thumbnail for new uploaded videos
          // Fetching thumbnail from tiktok API if denali thumbnail not present
          const result = await axios(
            `https://www.tiktok.com/oembed?url=${
              video.video_url || video.videoUrl
            }`
          );
          thumbnail_url = result.data.thumbnail_url;
        }

        setData({ thumbnail_url });
      } catch (error) {
        // Handle specific errors here, e.g., network error, HTTP error, etc.
        if (error.response) {
          console.error("HTTP Error:", error.response.status);
        } else if (error.request) {
          console.error("Network Error:", error.request);
        } else {
          console.error("Error:", error.message);
        }

        setData({
          isDeleted: true,
          thumbnail_url:
            require("@src/assets/images/vyrill/dropbox-deleted.png").default,
        });
      }
    };

    fetchData();
  }, [video]);

  return (
    <div className="text-center" style={customStyle}>
      <img
        src={data.thumbnail_url}
        style={
          data?.isDeleted ? { width: "100%", borderRadius: "10px" } : imgStyle
        }
        alt="Tiktok"
      />
    </div>
  );
};

export default React.memo(GenerateTiktokThumbnail);
